import { env } from '@/constant/configure';

const DeveloperView = ({ children, ...props }: Record<string, any>) => {

    return (
        <>{env !== 'prd' ? children : ''}</>
    )
}

export default DeveloperView;